import is from 'typescript-styled-is'
import styled, { ITheme } from '../../../../theme'
import BaseInput from '../../elements/Input'

const Input = styled(BaseInput)<IInputProps>`
  min-width: 30px;

  text-align: end;
  background: none;
  
  color: ${(props: ITheme) => props.theme.colors.palette.darkGreyTwo}
	
  padding: 0 ${({ size }) => (size ? 50 * size : 50)}px 0 ${({ size }) =>
  size ? 50 * size : 50}px;
  
  
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  -moz-appearance:textfield;
  
  border-radius: 4px 0px 0px 4px;
  
    ${is('selected')`
    border: 2px solid ${({ theme }: ITheme) => theme.colors.palette.emerald};
    &:focus {
      border: 2px solid ${({ theme }: ITheme) => theme.colors.palette.emerald};
    }
  `}
  ${is('error')`
    border: 2px solid ${({ theme }: ITheme) => theme.colors.palette.reddish};
    &:focus {
      border: 2px solid ${({ theme }: ITheme) => theme.colors.palette.reddish};
    }
  `}
  ${is('warning')`
    border: 2px solid ${({ theme }: ITheme) => theme.colors.palette.tangerine};
    &:focus {
      border: 2px solid ${({ theme }: ITheme) =>
        theme.colors.palette.tangerine};
    }
  `};
  
`

export default Input

export interface IInputProps {
  disabled?: boolean
}
